export const urls = {
  local: 'http://localhost:4000/rest',
  development: 'https://recrm-dd33eadabf10.herokuapp.com/rest',
  production: 'https://recrm-dd33eadabf10.herokuapp.com/rest'
};
